<template>
	<Pupup :width="800" class="uploader" :title="getTitle" @close="close">
		<template v-slot:content>
			<div class="slack-integration">
				<div v-if="!isSlackConnected">
					<h3>Connect with Slack</h3>
					<p>Allow our app to send notifications to your Slack workspace</p>
					<button @click="connectSlack" :disabled="loading">
						{{ loading ? "Connecting..." : "Connect with Slack" }}
					</button>
				</div>

				<div v-else>
					<h3>Choose a Slack Channel</h3>
					<div v-if="loading">Loading channels...</div>
					<div v-else>
						<select v-model="selectedChannel" class="channel-select">
							<option value="">Select a channel</option>
							<option v-for="channel in channels" :key="channel.id" :value="channel.id">#{{ channel.name }}</option>
						</select>

						<button @click="saveChannel" :disabled="!selectedChannel || savingChannel">
							{{ savingChannel ? "Saving..." : "Save Channel" }}
						</button>

						<div v-if="savedChannel" class="success-message">You'll now receive notifications in #{{ savedChannelName }}</div>
					</div>
				</div>
			</div>
		</template>
	</Pupup>
</template>

<script>
// https://serversideup.net/drag-and-drop-file-uploads-with-vuejs-and-axios/
import ApiService from "./../../services/api.service";
import Pupup from "./Pupup.vue";
import { mapState, mapMutations } from "vuex";
export default {
	name: "Slack",
	components: { Pupup },
	props: {},
	data() {
		return {
			isSlackConnected: false,
			loading: false,
			channels: [],
			selectedChannel: "",
			savingChannel: false,
			savedChannel: false,
			savedChannelName: "",
		};
	},

	async mounted() {
		this.checkSlackConnection();
	},

	computed: {
		...mapState("notifications", ["slackPupupTitle"]),
		getTitle() {
			return this.slackPupupTitle;
		},
	},

	methods: {
		...mapMutations("notifications", ["closeSlackPupup"]),
		close() {
			this.closeSlackPupup();
		},

		async checkSlackConnection() {
			try {
				const response = await ApiService.get("slack/status");
				this.isSlackConnected = response.data.connected;

				if (this.isSlackConnected) {
					this.fetchChannels();
					this.savedChannelName = response.data.channelName || "";
					this.savedChannel = !!this.savedChannelName;
				}
			} catch (error) {
				console.error("Error checking Slack status", error);
			}
		},

		async connectSlack() {
			try {
				this.loading = true;
				const response = await ApiService.get("slack/auth");

				window.location.assign(response.data.url);
			} catch (error) {
				console.error("Error checking Slack status", error);
			}
		},

		async fetchChannels() {
			this.loading = true;
			try {
				const response = await ApiService.get("slack/channels");
				this.channels = response.data.channels;
			} catch (error) {
				console.error("Error fetching channels", error);
			} finally {
				this.loading = false;
			}
		},

		async saveChannel() {
			if (!this.selectedChannel) return;

			this.savingChannel = true;
			try {
				const channelName = this.channels.find((c) => c.id === this.selectedChannel).name;

				await ApiService.post("slack/select-channel", {
					channelId: this.selectedChannel,
					channelName,
				});

				this.savedChannel = true;
				this.savedChannelName = channelName;
			} catch (error) {
				console.error("Error saving channel", error);
			} finally {
				this.savingChannel = false;
			}
		},
	},
};
</script>
<style lang="less" scoped>
@import "./../../assets/css/less/_settings.less";
@import "./../../assets/css/less/_helper.less";
</style>